/* @flow */
import cx from 'classnames';
import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import UserLink from 'users/components/UserLink.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import shallowCompare from 'react-addons-shallow-compare';
import PhoneCallMessageItem from './PhoneCallMessageItem.jsx';
import RelationshipModal from 'user/components/RelationshipModal.jsx';

import './styles/MessageListItem.scss';

type Props = {
  messages: Array<PhoneCallMessageGQL>,
  disabled?: boolean,
};

class PhoneCallMessageListItem extends React.Component<Props, *> {
  static defaultProps = {
    disabled: false,
  };

  shouldComponentUpdate(nextProps: Props, nextState: *) {
    return shallowCompare(this, nextProps, nextState);
  }

  getSender() {
    return this.props.messages[0].sender;
  }

  sentByCurrentUser() {
    return CurrentUser.getUserUuid() === this.getSender().uuid;
  }

  renderName() {
    const sender = this.getSender();
    const modal = <RelationshipModal userId={sender.id} />;

    return (
      <ModalTrigger modal={modal}>
        <UserLink
          userId={sender.id}
          neverShowStartChat
          placement="right"
          color="inherit"
          alignment="top">
          <span
            className={cx('MessageListItem-name', {
              'MessageListItem-disabled': this.props.disabled,
            })}
            disabled={this.props.disabled}>
            {sender.name}
          </span>
        </UserLink>
      </ModalTrigger>
    );
  }

  renderMessage(message: PhoneCallMessageGQL, isCurrentUser: boolean, lastOfGroup: boolean) {
    return (
      <PhoneCallMessageItem
        key={message.uuid}
        message={message}
        sentBySelf={isCurrentUser}
        lastOfGroup={lastOfGroup}
      />
    );
  }

  renderContent() {
    const { messages } = this.props;
    const sentByCurrentUser = this.sentByCurrentUser();
    const messageItems = messages.map(message => {
      const lastOfGroup = message === messages[messages.length - 1];
      return this.renderMessage(message, sentByCurrentUser, lastOfGroup);
    });

    if (sentByCurrentUser) {
      return <div className="MessageListItem-content">{messageItems}</div>;
    }

    return (
      <div className="MessageListItem-messageGroup">
        <div className="MessageListItem-contentWrap">
          {this.renderName()}
          <div className="MessageListItem-content">{messageItems}</div>
        </div>
      </div>
    );
  }

  render() {
    const sentByCurrentUser = this.sentByCurrentUser();

    return (
      <li
        className={cx('MessageListItem', {
          'MessageListItem-self': sentByCurrentUser,
          'MessageListItem-other': !sentByCurrentUser,
        })}>
        {this.renderContent()}
      </li>
    );
  }
}

export default PhoneCallMessageListItem;
